import Students from "../pages/admin/students";

export const academicDeanUrls = {
    index: {
        path: '/',
        exact: true,
        component: Students,
    },
}